import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';


const styles = theme => ({
  root: {
    minWidth: theme.dimensions.md,
  },
  content: {
    width: '100%',
  },
  continueButton: {
    padding: theme.spacing(1),
  },
  stepNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(3),
  },
});

const GenericStrategyStartDateStep = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaControlField
        attr={'startDate'}
      />
    </Box>
  );
};

GenericStrategyStartDateStep.defaultProps = {
  className: '',
};

GenericStrategyStartDateStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GenericStrategyStartDateStep);
